import React from 'react';
import { safeJsonLd } from '../../utils/seoHead';

export default function SeoStructuredData({ data }) {
  if (!data) return null;
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: safeJsonLd(data) }} />;
}
